// src/reducers/paymentReducer.js

const initialState = {
    loading: false,
    error: null
  };
  
  export default function(state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      // You can add action types here later if needed, for example:
      // case 'PAYMENT_INITIATED':
      //   return { ...state, loading: true };
      // case 'PAYMENT_SUCCESS':
      //   return { ...state, loading: false };
      // case 'PAYMENT_FAILURE':
      //   return { ...state, loading: false, error: payload };
      default:
        return state;
    }
  }